import type { ChangePasswordResponse, MeResponse, UserDto } from '@ledokol/contracts'
import { api, setAccessToken } from './client'

export async function login(email: string, password: string): Promise<UserDto> {
  const r = await api.post<{ user: UserDto; access_token: string }>('/auth/login', { email, password })
  setAccessToken(r.data.access_token)
  return r.data.user
}

export async function logout(): Promise<void> {
  try {
    await api.post('/auth/logout')
  } finally {
    setAccessToken(null)
  }
}

export async function fetchMe(): Promise<MeResponse> {
  const r = await api.get<MeResponse>('/me')
  return r.data
}

/**
 * POST /me/password. Сервер отзывает все остальные сессии и выдаёт новую пару токенов
 * текущей: access кладём в память, refresh приходит httpOnly-кукой.
 */
export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  const r = await api.post<ChangePasswordResponse>('/me/password', {
    current_password: currentPassword,
    new_password: newPassword,
  })
  setAccessToken(r.data.access_token)
}
